import { format } from "date-fns";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { AccountingReportType } from "@common/types/reports/report-type";
import {
    SCHEDULES_REPORT_TITLES,
    SchedulesReportLayout,
} from "@common/types/reports/schedules-report";
import { ReportVariableContext } from "@common/helpers/report-variables";
import { fullDateFullYearFormat, yearOnlyFormat } from "@common/helpers/date";
import { DATE_RANGE_PRESETS_BY_ID } from "@helpers/date";

export const PREVIEW_SAMPLE_ENTITY_NAME = "Internet Money";

const POINT_IN_TIME_REPORTS: AccountingReportType[] = [
    AccountingReportType.BALANCE_SHEET,
    AccountingReportType.TRIAL_BALANCE,
    AccountingReportType.AR_AGING_SUMMARY,
    AccountingReportType.AR_AGING_DETAIL,
];

const ACCRUAL_ONLY_REPORTS: AccountingReportType[] = [
    AccountingReportType.AR_AGING_SUMMARY,
    AccountingReportType.AR_AGING_DETAIL,
];

interface BuildPreviewVariableContextParams {
    reportType: AccountingReportType;
    entityName: string | null;
    firmName: string | null;
}

export const buildPreviewVariableContext = ({
    reportType,
    entityName,
    firmName,
}: BuildPreviewVariableContextParams): ReportVariableContext => {
    const now = new Date();
    const lastYear = DATE_RANGE_PRESETS_BY_ID.last_year;
    return {
        reportType,
        entityName,
        firmName,
        reportTitle:
            reportType === AccountingReportType.SCHEDULES
                ? SCHEDULES_REPORT_TITLES[SchedulesReportLayout.rollforward]
                : null,
        isPointInTime: POINT_IN_TIME_REPORTS.includes(reportType),
        periodStart: lastYear.getStart(now),
        periodEnd: lastYear.getEnd(now),
        basis: ACCRUAL_ONLY_REPORTS.includes(reportType)
            ? AccountingLedgerBasis.accruals
            : AccountingLedgerBasis.cash,
        isMixedBasis: false,
        now,
    };
};

export const getPreviewAmountHeader = ({
    isPointInTime,
    periodEnd,
}: {
    isPointInTime: boolean;
    periodEnd: Date;
}): string =>
    format(periodEnd, isPointInTime ? fullDateFullYearFormat : yearOnlyFormat);
